<template>
  <div class="propertyService">
    <div class="headTitle">
      <div class="shadowTxt">PROPERTY</div>
      <div class="title">物业服务</div>
      <div class="text">
        爱情物业具有物业管理国家二级资质，是中国物业管理协会会员单位，拥有丰富的物业管理经验及高素质人才服务队伍。
        <br />目前，公司已经布局京津冀、华东、华中、成渝、长三角、珠三角等最具活力的城市群，管理面积超过800万平方米，物业涵盖住宅服务、商办服务、案场服务等多业务版块。
      </div>
    </div>
    <div class="dataInfo">
      <!-- <div class="tips">*数据截止2021年4月</div> -->
      <div class="companyInfo">
        <div class="companyPart">
          <div class="num">2012<span class="year">年</span></div>
          <div class="txt">成立于</div>
        </div>
        <div class="line"></div>
        <div class="companyPart">
          <div class="num">800w<span class="add">+</span><sub>m²</sub></div>
          <div class="txt">管理面积</div>
        </div>
        <div class="line"></div>
        <div class="companyPart">
          <div class="num">20<span class="add">+</span></div>
          <div class="txt">入驻城市</div>
        </div>
      </div>
    </div>
    <div class="gnTitle">
      <div class="gnTit">
        <div class="orange"></div>
        <h5>服务品类</h5>
        <span>OUR SERVICE</span>
      </div>
    </div>
    <div class="serviceText">
      爱情物业服务包括基础物业服务、智慧物业平台、社区多元化经营和社区活动四大类。在保障高品质基础服务的前提下，通过创新，对物业服务的内容进行升级和扩展，不断满足业主与时俱进的生活服务需求。
    </div>
    <div class="rectBox">
      <div class="rect">
        <div class="rect-item" v-for="(item, idx) in typeList" :key="`${idx}`">
          <div class="rect-left">
            <img src="../../assets/images/circle.png" alt="" class="point" />
            <div class="line"></div>
          </div>
          <div class="rect-right">
            <div class="rect-name">{{ item.name }}</div>
            <div class="rect-suggest">{{ item.suggest }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="system">
        <div class="gnTitle">
            <div class="gnTit">
                <div class="orange"></div>
                <h5>服务体系</h5>
                <span>SERVICE</span>
            </div>
        </div>
        <div class="serviceText">
          针对社区建筑业态，和广大业主对物业服务的内容、质量、细节品味等多方面的需求，爱情物业以更加贴心的服务形式，推出“六新服务”体系，以满足社区业主精神和实际生活层面的服务需求，让业主真切体会感受到“以爱相伴，情暖一生”的幸福暖意。
        </div>
        <div class="iconPart">
          
            <div class="part">
              <div class="item" v-for="(item, idx) in systemList" :key="`${idx}`">
                <div class="iconImg"><img :src="item.img" alt=""></div>
                <div class="iconTxt">{{item.name}}</div>
              </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import { ESTATE_TYPE_LIST , ESTATE_SYSTEM_LIST} from "./property";
export default {
  metaInfo: {
      title: '物业服务-爱情地产',
      meta: [{
      name: 'keyWords',
      content: '爱情地产'
      },
      {
      name: 'description',
      content: ''
      }]
  },
  data() {
    return {
      typeList: ESTATE_TYPE_LIST,
      systemList: ESTATE_SYSTEM_LIST,
    };
  },
};
</script>
<style lang="less" scoped>
*{
  margin: 0;
  padding: 0;
}
img{
  width: 100%;
}
.headTitle {
  padding: 20px 15px 7px 15px;
  background: #fff;
  .shadowTxt {
    font-size: 40px;
    line-height: 47px;
    color: #f8f8f8;
    font-family: "DIN Alternate Bold";
    font-weight: bold;
  }
  .title {
    color: #222;
    font-size: 18px;
    line-height: 25px;
    font-family: "苹方-简 中黑体";
    font-weight: 600;
    margin-top: -28px;
  }
  .text {
    color: #666666;
    font-size: 13px;
    line-height: 20px;
    font-family: "苹方-简 常规体";
    margin-top: 9px;
  }
}
.dataInfo {
  padding: 16px 0 25px 0;
  background: url("../../assets/images/bg.png") no-repeat top left;
  background-size: 100% 100%;
  .tips {
    font-family: "苹方-简 常规体";
    color: #ccc;
    font-size: 10px;
    line-height: 14px;
    text-align: right;
    padding-right: 16px;
    padding-bottom: 15px;
  }
  .companyInfo {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .line {
      width: 1px;
      height: 64px;
      background: #fff;
    }
    .companyPart {
      text-align:center ;
      .num {
        text-align: center;
        color: #e95506;
        font-family: "DIN Alternate Bold";
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        .year{
          font-size: 10px;
          line-height: 14px;
          color: #E95506;
          font-family: '苹方-简 常规体';
          font-weight: normal;
        }
        .add{
          font-size: 10px;
          line-height: 14px;
          color: #E95506;
          font-family: '苹方-简 中粗体';
          vertical-align: top;
        }
        sub {
          font-size: 10px;
          line-height: 14px;
          font-family: '苹方-简 常规体';
          font-weight: normal;
        }
      }
      .txt {
        color: #666;
        font-family: "苹方-简 常规体";
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
}
.gnTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  .gnTit {
    font-family: "苹方-简 中黑体";
    font-size: 18px;
    line-height: 25px;
    color: #333;
    margin: 0;
    font-weight: bold;
    position: relative;
    .orange {
      display: inline-block;
      width: 33px;
      height: 10px;
      background: #ee6a09;
      // opacity: 0.8;
      position: absolute;
    }
    h5{
      font-size: 18px;
      line-height: 25px;
      color: #333;
      font-family: '苹方-简 中黑体';
      z-index: 99;
      position: relative;
      font-weight: 600;
      margin: 0;
      letter-spacing: 0;
      display:inline-block;
    }
    span {
      font-family: "苹方-简 常规体";
      color: #cccccc;
      font-size: 12px;
      line-height: 17px;
      font-weight: 500;
      margin-left: 10px;
    }
  }
}
.serviceText {
  padding: 0 15px 15px;
  font-family: "苹方-简 常规体";
  color: #666;
  font-size: 13px;
  line-height: 20px;
}
.rectBox{
    background: url('../../assets/images/bg2.png') no-repeat top left;
    background-size: 100% 100%;
    padding: 0 14px 28px 16px;
    .rect {
    width: 345px;
    height: 248px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 7.75px;
    padding: 26px 0 0 37px;
    box-shadow: 0 -10px 16px 2px #f8f8f8;
  &:first-child {
    margin-top: 0;
  }
  .rect-item {
    display: flex;
    &:first-child {
      margin-top: 0;
    }
    .rect-left {
      position: relative;
      .point {
        width: 10px;
        margin-top: -45px;
      }
      .line {
        position: absolute;
        left: 5px;
        margin-left: -0.4px;
        top: 0;
        bottom: -15px;
        border: 1px dashed #EFEFEF;
        transform: scale(0.8);
      }
    }
    .rect-right {
      padding-left: 15px;
    }
    .rect-name {
      font-size: 14px;
      line-height: 20px;
      font-family: '苹方-简 中黑体';
      font-weight: 500;
      color: #333333;
    }
    .rect-suggest {
      margin-top: 5px;
      font-size: 12px;
      line-height: 17px;
      letter-spacing:0.75px;
      font-family: '苹方-简 常规体';
      font-weight: 400;
      color: #999999;
    }
  }
}
}
.iconPart{
  padding-top: 5px;
  .part{
    overflow: hidden;
    padding-left: 35px;
    .item{
      text-align: center;
      float: left;
      margin-right: 89px;
      margin-bottom: 30px;
      &:nth-child(3n){
        margin-right: 0;
      }
      .iconImg{
        width: 36px;
        height: 36px;
        // border: 1px dotted #333;
        display: flex;
        margin: auto;
      }
      .iconTxt{
        font-size: 13px;
        line-height: 20px;
        color: #333;
        font-family: '苹方-简 常规体';
        margin-top: 5px;
      }
    }
  }
}

</style>
